import React from 'react'
import { useHistory } from 'react-router-dom'
import Button from '../../../../utils/components/Button/Button'
import { Table } from '../../../components/Table/Table'

const ListRoles = ({roles}) => {
    const history = useHistory()
  return (
    <div>
        <div className='column mb-5'>
                <Button
                    onClick={() => {
                        history.push("/Admin/CreateRole")
                    }}
                    text='Crear Rol'
                />
            </div>
        <Table>
            <thead>
                <tr>
                    <th>Nombre</th>
                    <th>Permisos</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
            {
                roles.map(rol=>(
                    <tr key={rol._id}>
                        <td>{rol.name}</td>
                        <td>{rol.permissionsIds.map((permision,index)=>(
                            permision.name
                        )).join(", ")}</td>
                        <td>
                            <Button 
                                onClick={()=>history.push("/Admin/Role/"+rol._id)}
                            text='Editar' />
                        </td>
                    </tr>
                ))
            }
            </tbody>
          
        </Table>
    </div>
  )
}

export default ListRoles